import moment from 'moment';
import { Storage } from './Storage';
import { removeHTMLTag } from 'grt-web-components';

export const debuggerkey = 'grtDebugger';
export const getTenantId = () => {
    return Storage.get('TENANT_KEY');
};
export const isXinWu = () => {
    let id = getTenantId();

    if (String(id) === '1801176995993874433') {
        return true;
    }
    return false;
};
export const getQueryVariable = function (name) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i'),
        result = window.location.search.substr(1).match(reg);
    if (result) return decodeURIComponent(result[2]);
    return null;
};
export const isNingBo = () => {
    let id = getTenantId();

    if (String(id) === '1820398782906961922') {
        return true;
    }
    return false;
};
export const objToSearch = (obj) => {
    let res = '?',
        keysArr = Object.keys(obj),
        len = keysArr.length;
    keysArr.forEach((ele, index) => {
        if (index < len - 1) {
            res += `${ele}=${obj[ele]}&`;
        } else {
            res += `${ele}=${obj[ele]}`;
        }
    });
    return res;
};
export const objectToUrlSearchParams = (obj) => {
    let searchParams = new URLSearchParams();
    for (let key in obj) {
        searchParams.append(key, obj[key]);
    }
    return searchParams.toString();
};

export const urlSearchParamsToObject = (url) => {
    let location = new URL(url),
        searchParams = new URLSearchParams(location.search),
        paramsObject = {};
    for (let [key, value] of searchParams) {
        paramsObject[key] = value;
    }
    return paramsObject;
};

export const getFormatDate = (str, format) => {
    if (str) {
        if (typeof str === 'number') {
            return moment(str).format(format);
        }
        if (typeof str === 'string' && String(Number(str)).length === str.length) {
            return moment(Number(str)).format(format);
        }
        return moment(str).format(format);
    }
    return null;
};

const getTextValue = (type, value) => {
        if (!value && typeof value !== 'number') return '';
        switch (type) {
            case 'text':
            case 'textarea':
                return value;
            case 'tag':
                return value?.join('、') || '';
            default:
                return value;
        }
    },
    getSelectValue = (type, value, options) => {
        if (!value && typeof value !== 'number') return '';
        switch (type) {
            case 'single':
                return options?.find((item) => item.id === value)?.name || '';
            case 'multiple':
                return (
                    options
                        ?.filter((item) => (value || []).some((v) => v === item.id))
                        ?.map((item) => item.name)
                        ?.join('、') || ''
                );
            default:
                return value;
        }
    },
    getDateValue = (type, value, format = 'YYYY-MM-DD') => {
        if (!value && typeof value !== 'number') return '';
        switch (type) {
            case 'date':
                return value ? moment(value).format(format) : '';
            case 'range':
                return value?.map((item) => moment(item).format(format))?.join(' - ') || '';
            default:
                return value;
        }
    },
    getDateFormat = (type) => {
        switch (type) {
            case 1:
                return 'YYYY';
            case 2:
                return 'YYYY-MM';
            case 3:
                return 'YYYY-MM-DD';
            case 4:
                return 'YYYY-MM-DD HH:mm:ss';
            default:
                return 'YYYY-MM-DD';
        }
    },
    getValue = (field, fieldsValue) => {
        switch (field.field_type) {
            // 文本
            case 1:
                return getTextValue(field.setting.type, fieldsValue[field.en_name]);
            // 下拉
            case 2:
                return getSelectValue(field.setting.type, fieldsValue[field.en_name], field.setting.options);
            // 数值
            case 3:
                return fieldsValue[field.en_name];
            // 日期
            case 5:
                return getDateValue(field.setting.type, fieldsValue[field.en_name], getDateFormat(field.setting.showTime));
            default:
                return fieldsValue[field.en_name];
        }
    };

/**
 * 将自定义字段转化为对象 {key, label, value} 形式展示
 *
 * @param {Object} fields - 包含字段信息的对象
 * @param {Object} fields.field_key - 字段的键
 * @param {string} fields.field_key.en_name - 字段的英文名称
 * @param {1 | 2 | 3 | 5} fields.field_key.field_type - 字段的类型
 * @param {string} fields.field_key.name - 字段的名称
 * @param {any} fields.field_key.setting - 字段的设置
 * @param {Object} fields.field_value - 字段的值
 * @param {string | number | string[] | number[]} fields.field_value[key] - 每个字段的值
 * @param {any} [fields.any] - 其他任意字段
 * @returns {{key: string; label: string; value: string | number;}[]} newList - 转换后的对象数组
 */
export const mapFieldsToObject = (fields) => {
    if (!fields || !fields.field_key || !fields.field_key.length) return [];
    const newList = [],
        fieldsKeys = fields.field_key || [],
        fieldsValue = fields?.field_value || {};

    fieldsKeys.forEach((field) => {
        newList.push({
            key: field.en_name,
            label: field.name,
            value: getValue(field, fieldsValue)
        });
    });
    return newList;
};
//获取随机数
export const getIntRandom = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const HtmlUtil = {
    /*用浏览器内部转换器实现html解码（反转义）*/
    htmlDecode: function (text) {
        //1.首先动态创建一个容器标签元素，如DIV
        let temp = document.createElement('div');
        //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
        temp.innerHTML = text;
        //3.最后返回这个元素的innerText或者textContent，即得到经过HTML解码的字符串了。
        let output = temp.innerText || temp.textContent;
        temp = null;
        return output;
    }
};

//帖子列表 产品需求有img 标签的替换为[图片]
export const HtmlReplaceImg = (text) => {
    return text ? text.replace(/<img[^>]*\/?>/g, '[图片]') : text;
};
export const goInvalidLink = () => {
    window.location.replace('/web/invalid-link');
};
//判断是否是无效的链接---考试、练习中使用该方法
export const IsInValidLink = (props) => {
    const searchParams = new URLSearchParams(window.location.search);
    let uState = searchParams.get('state');

    if (uState) {
        searchParams.delete('state');
        props.setSearchParams(searchParams.toString(), { replace: true });
        //存储到session中----在此页面刷新时 使用
        Storage.set('state', 'true', false);
        return false;
    }
    let sState = Storage.get('state', false);
    if (!sState) {
        goInvalidLink();
        return true;
    }
    return false;
};

export const hasContent = (val) => {
    let text = removeHTMLTag(val),
        flag = /<img[^>]+>/.test(val);
    if (text || flag) return true;
    return false;
};
//定时器
export const  delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
